import _defineProperty from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "selected", "className"];
import { jsx } from 'react/jsx-runtime';
import clsx from 'clsx';
import { forwardRef } from 'react';
import { ToolbarButton } from './toolbar-button.js';
import styles from './toolbar.module.js';
var ToolbarTriggerButton = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var children = props.children,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      className = props.className,
      rest = _objectWithoutProperties(props, _excluded);

  var selectionStateAttrs = {
    'data-state': selected ? 'on' : 'off',
    'aria-pressed': Boolean(selected)
  };
  return jsx(ToolbarButton, _objectSpread(_objectSpread(_objectSpread({}, rest), selectionStateAttrs), {}, {
    ref: forwardedRef,
    className: clsx(className, _defineProperty({}, styles.triggerButtonSelectedWithColor, props.backgroundColor && selected)),
    children: children
  }));
});
export { ToolbarTriggerButton };